import {Component, inject, OnInit, Signal, signal} from '@angular/core';
import {AuthService} from '../../core/auth/auth-service';
import {ButtonModule} from 'primeng/button';
import {CardModule} from "primeng/card";
import {Router} from '@angular/router';
import {CommonModule} from '@angular/common';
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {InputTextModule} from 'primeng/inputtext';
import {DividerModule} from 'primeng/divider';
import {Password} from 'primeng/password';
import {AuthSessionState} from '../../core/auth/auth-session.state';
import {Message} from 'primeng/message';
import {MenuService} from '../../core/services/menu.service';
import {DeviceService} from '../../core/services/device.service';
import {StoreDbService} from '../../core/db/store.db.service';
import {Dialog} from 'primeng/dialog';
import {AppVersionService} from '../../core/services/app-version.service';
import {LoginResult} from '../../core/interfaces/login-result-interface';
import {RegistroEquipoService} from '../administracion/registro-equipo/services/registro-equipo';
import {DbStore} from '../../core/db/models/db-store.model';
import {ObtenerEquipoResponse} from '../administracion/registro-equipo/interfaces/obtener-equipo-response-interface';

import {CryptoService} from '../../core/auth/crypto';
import {TipoPuntoVentaEnum} from '../../shared/enums/tipo-punto-venta-enum';
import {
  SelectPuntoVentaRequest
} from '../administracion/seleccionar-punto-venta/interfaces/select-punto-venta-request-interface';
import {SeleccionarPuntoVentaService} from '../administracion/seleccionar-punto-venta/services/seleccionar-punto-venta';
import {Tooltip} from 'primeng/tooltip';
import {
  ConfiguracionTemporalModal
} from '../../shared/components/configuracion-temporal-modal/configuracion-temporal-modal';
import {DialogService, DynamicDialogRef} from 'primeng/dynamicdialog';
import {BackendUser} from '../../core/interfaces/UserInterface';
import {IdleService} from '../../shared/services/idle.service';
import {AlertService} from '../../shared/services/alert.service';
import {LoadingService} from '../../shared/components/loading/loading.service';
import {ObtenerEquipoRequest} from '../administracion/registro-equipo/interfaces/obtener-equipo-request-interface';
import {Select} from 'primeng/select';
import {
  RegistrarEquipoInterface
} from '../administracion/registro-equipo/interfaces/registrar-equipo-request-interface';
import {
  CORPORATIVOS_REGISTRO,
  CorporativoRegistro
} from '../../shared/constants/corporativos-registro.constant';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    ButtonModule,
    CardModule,
    CommonModule,
    ReactiveFormsModule,
    ButtonModule,
    InputTextModule,
    DividerModule,
    Password,
    Message,
    Dialog,
    Tooltip,
    Select,
    FormsModule
  ],
  templateUrl: './login.html',
  styleUrl: './login.scss',
})
export class Login implements OnInit {
  private authService = inject(AuthService);
  private router = inject(Router);
  private session = inject(AuthSessionState);
  private menuService = inject(MenuService);
  private deviceService = inject(DeviceService);
  private storeDb = inject(StoreDbService);
  private registroEquipo = inject(RegistroEquipoService);
  public loadingService = inject(LoadingService);
  private cryptoService = inject(CryptoService);
  private storeDbService = inject(StoreDbService);
  private auth = inject(AuthService);
  private selectPuntoVentaService = inject(SeleccionarPuntoVentaService);
  private dialogService = inject(DialogService);
  private idleService = inject(IdleService);
  private alertService = inject(AlertService);
  private user: Signal<BackendUser | null>;
  public deviceId!: string;
  store: DbStore | undefined;
  ref: DynamicDialogRef<ConfiguracionTemporalModal> | null = null;
  public tipoTienda = TipoPuntoVentaEnum;
  versionService = inject(AppVersionService);
  loading = signal(false);
  form: FormGroup;
  errorMessage = '';
  private fb = new FormBuilder();
  showRegisterModal = false;
  year  =new Date().getFullYear();
  showidleModal = false;
  minutos  = this.idleService.timeout / 60000;
  equipoRegistrado = signal(false);
  corporativos = CORPORATIVOS_REGISTRO;

  corporativoSeleccionado =
    signal<CorporativoRegistro | null>(null);
  constructor() {
    this.form = this.fb.group({
      email: ['', [Validators.required]],
      password: ['', Validators.required],
    });
    this.user = this.session.rawBackend;
  }

  async ngOnInit() {
    this.loading.set(true);
    await this.loadDevice();
  }

  async loadDevice() {
    this.loadingService.show('Validando dispositivo...');
    this.deviceId = await this.deviceService.getDeviceId();
    //incorrecta o null manda a pantalla de registro
    const exists = await this.storeDb.hasStore();
    if (!exists) {
      const data: ObtenerEquipoRequest = {payload: {
        fingerWeb: this.deviceId
      }};
      this.registroEquipo.obtenerEquipo(data).subscribe({
        next: async (response) => {
          //correcta se queda en login y llena los datos,
          if(response.payload){
            const dataStore = this.transformData(response.payload);
            await this.storeDb.saveStore(dataStore);
            this.store = await this.storeDbService.getConfig();
            this.equipoRegistrado.set(true);
            await this.switchStore();
          } else {
            // No hay datos, ya no muestra el modal para ir a registro, habilita un combo de corporativos
            // this.showRegisterModal = true;
            // this.loading.set(false);
            // this.loadingService.hide();
            this.equipoRegistrado.set(false);
            this.store = undefined;
            this.loading.set(false);
            this.loadingService.hide();
          }

        },
        error: err => {
          console.error('Error en logout', err);
          // this.showRegisterModal = true;
          // this.loading.set(false);
          // this.loadingService.hide();
          this.equipoRegistrado.set(false);
          this.store = undefined;
          this.loading.set(false);
          this.loadingService.hide();
        }
      });
    } else {
      this.store = await this.storeDbService.getConfig();
      this.equipoRegistrado.set(true);
      await this.getObtenerRegistro();
    }
  }

  async getObtenerRegistro(){
    const data: ObtenerEquipoRequest = {payload: {
        fingerWeb: this.deviceId
      }};
    this.registroEquipo.obtenerEquipo(data).subscribe({
      next: async (response) => {
        if (response.exception){
          if (this.getExceptionCode(response.exception) === '003') {
            await this.habilitarRegistroRapido();
            return;
          }

          this.errorMessage = this.extractErrorMessage(response.exception);
          this.loading.set(false);
          this.loadingService.hide();
          return;
        }
        const lista = response.payload?.listaRegistroSesionPuntoVenta;
        if (!lista?.length) return;
        const registroDefault = lista.find(x => x.default === 1);

        if (registroDefault && this.store) {
          const configTemporal = localStorage.getItem('configTemporal') === 'true';
          if(this.store.puntoVentaOriginal !== registroDefault.puntoVenta && !configTemporal){
            // console.log('son diferentes aca tendria que almacenar el objeto nuevo en indexed db');
            const nuevoStore = {
              key: 'store-id',
              value: response.payload.fingerWeb,
              pais: response.payload.paisOriginal,
              puntoVenta: response.payload.pvOriginal.puntoVenta,
              sesionMultiple: response.payload.sesionMultiple === 1,
              cambiarPV: response.payload.cambiarPV === 1,
              nuevaPantalla: false,
              descripcionPais: response.payload.paisOriginal,
              esSociedad: false,
              paisActivo: true,
              activo: response.payload.activo,
              descripcionPuntoVenta: response.payload.pvOriginal.descripcion,
              tipoPV: response.payload.pvOriginal.tipoPuntoVenta,
              pvDefault: true,
              fingerWeb: response.payload.fingerWeb,
              impresoraAlmacen: response.payload.impresoraAlmacen,
              impresoraTienda: response.payload.impresoraTienda,
              impresoraZebra: response.payload.impresoraZebra,
              nev: response.payload.nev,
              paisOriginal: response.payload.paisOriginal,
              puntoVentaOriginal: response.payload.pvOriginal.puntoVenta,
              descripcionPuntoOriginal: response.payload.pvOriginal.descripcion,
              registro: new Date().toISOString(),
              razonSocial: response.payload.pvOriginal.razonSocial.SRazonSocial,
              imagenFondo: response.payload.pvOriginal.razonSocial.abreviatura
            };
            // guardamos los datos en indexedDB
            await this.storeDb.saveStore(nuevoStore);
            // console.log('cambio a esta tienda', nuevoStore);
            const data: SelectPuntoVentaRequest = {
              pais: response.payload.paisOriginal,
              payload: {
                default: 1,
                fingerWeb: this.deviceId,
                pais: response.payload.paisOriginal,
                paisRedireccion: response.payload.paisOriginal,
                puntoVentaRedireccion: response.payload.pvOriginal.puntoVenta,
                tipoVenta: response.payload.pvOriginal.tipoPuntoVenta
              }
            };
            // Actualizamos el pv para dejarlo sincronizado con el original
            await this.updatePV(data);
            // obtengo la nueva configuracion
            this.store = await this.storeDbService.getConfig();
            // Inhabilitamos la configuracion temporal
            localStorage.setItem('configTemporal', 'false');
            // para obligar a pedir el login cuando es corporativo
            if(response.payload.pvOriginal.tipoPuntoVenta === this.tipoTienda.Corporativo) {
              this.logout();
            } else if(response.payload.pvOriginal.tipoPuntoVenta === this.tipoTienda.PuntoVentaPropio){
              await this.switchStore();
            }
          }else {
            // console.log('son iguales o es temporal, no se realiza nada de logica');
            await this.switchStore();
          }
        }


      },
      error: err => {
        console.error('Error en logout', err);
        this.loading.set(false);
        this.alertService.warn('Error', `Ocurrio un error al obtener los datos del equipo, verifica tu conexión o intentalo mas tarde.`);
        this.loadingService.hide();
      }
    });
  }

  private async habilitarRegistroRapido(): Promise<void> {
    await this.storeDb.clear();
    localStorage.removeItem('configTemporal');
    this.store = undefined;
    this.equipoRegistrado.set(false);
    this.errorMessage = '';
    this.loading.set(false);
    this.loadingService.hide();
  }

  private getExceptionCode(exception: unknown): string | null {
    if (
      typeof exception === 'object' &&
      exception !== null &&
      'code' in exception
    ) {
      return String((exception as {code: unknown}).code);
    }

    return null;
  }

  async switchStore() {
    if(this.store !== undefined){
      switch(this.store.tipoPV){
        case this.tipoTienda.Corporativo:
          this.loading.set(false);
          this.loadingService.hide();
          const idle = localStorage.getItem('idle') === 'true';
          if(idle){ this.showidleModal =  true}
          break;
        case this.tipoTienda.PuntoVentaPropio:
          await this.router.navigateByUrl('/dashboard', {replaceUrl: true});
          this.loading.set(false);
          this.loadingService.hide();
          break;
        case this.tipoTienda.Franquicias:
          await this.router.navigateByUrl('/dashboard', {replaceUrl: true});
          this.loading.set(false);
          this.loadingService.hide();
          break;
      }
    }

  }

  updatePV(data: SelectPuntoVentaRequest):void {
    this.selectPuntoVentaService.actualizarPvDefault(data).subscribe({
      next: async (response) => {
        console.log(response);
      },
      error: (err: unknown) => {
        console.error('Error actualizando PV', err);
      }
    });
  }

  goToRegister() {
    this.showRegisterModal = false;
    this.router.navigateByUrl('/AdminRegistro', { replaceUrl: true });
  }

  // async onGoogleLogin() {
  //   this.loading.set(true);
  //
  //   await this.authService.getValidatedData().subscribe({
  //     next: (response: any) => {
  //      console.log(response);
  //     },
  //     error: (err: Error) => {
  //       console.error('Error total en la cadena:', err);
  //     }
  //   });
  // }

  async loginEmail() {
    if (this.form.invalid) return;

    // Validacion para registro silencioso
    if (!this.equipoRegistrado() && !this.corporativoSeleccionado()) {
      this.errorMessage = 'Selecciona un corporativo';
      return;
    }

    const { email, password } = this.form.value;

    // this.loading.set(true);
    this.loadingService.show('Validando credenciales');

    //TODO: Encriptar password , pendiente....
    /*const publicKey = `-----BEGIN PUBLIC KEY-----
    MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEArvF1lM1JzJrVN6a8GN28
    AL5soNqd7qV3CyMfCVxYvBy06SnVAk0nnBYnOVrlaR271GGBqBPdZiZsaAJ+lZeX
    I7IuAv89xDSHLVYRIlnJrped1IovnHgwlHGhEq+y3OCAXoTr4Wr9PXgY7vRl6VwB
    p6k9R/+qvOB0fOkH1ZZ1xd6Q671O5jM90+hCbGyF/F7fs/3Gzdh0dX8GZFODdgNp
    27C/7fyqCkCmZJLdnOjFkWDXLI4YAlnXrhIRbkIuAeGHWxirMRHkRkNvztNFVQVw
    Gc7YCOjxIqFZ3VAb9/T/jGj33jjlHzvEihQ/HVbUaz2QmiFjCwXTlzAIXazhbugX
    xwIDAQAB
    -----END PUBLIC KEY-----`;

    const encryptedPassword = await this.cryptoService.encryptPassword(
      password,
      publicKey
    );
    console.log(encryptedPassword);*/

    const puntoVenta = this.equipoRegistrado()
      ? this.store!.puntoVenta
      : this.corporativoSeleccionado()!.puntoVenta;

    const pais = this.equipoRegistrado()
      ? this.store!.pais
      : this.corporativoSeleccionado()!.pais;
    const tipoPuntoVenta = this.equipoRegistrado()
      ? this.store!.tipoPV
      : this.corporativoSeleccionado()!.tipoPuntoVenta;
    this.errorMessage = '';

    return this.authService.loginBackedWithEmailAndPassword(email!, password!, puntoVenta, pais, tipoPuntoVenta)
      .subscribe({
        next: async (response: LoginResult) => {

          if (!response.ok) {
            this.errorMessage = this.extractErrorMessage(response.exception);
            // this.loading.set(false);
            this.loadingService.hide();
            return;
          }
          if(response.token){
            const token = response.token;
            const user = response.claims!;

            if (!this.store) {
              const registrado =
                await this.registrarEquipoSilencioso();

              if (!registrado) {
                this.loadingService.hide();
                return;
              }
            }


            const raw = response.rawBackend;
            if (!raw) {
              this.errorMessage = 'Sesión inválida';
              // this.loading.set(false);
              this.loadingService.hide();
              return;
            }

            await this.session.setBackendSession(token, user, raw);
            // Resetear IndexedDB
            await this.authService.persistSessionData(raw,user.user_id);
            // Actualizar Menu
            // await this.menuService.refresh();
            this.router.navigateByUrl('/dashboard', { replaceUrl: true })
          } else if (response.exception){
            this.errorMessage = this.extractErrorMessage(response.exception);
          }
          // this.loading.set(false);
          this.loadingService.hide();
        },
        error: err => {
          console.log(err);
          console.error(err);

          this.errorMessage = 'No pudimos verificar tu usuario, intenta de nuevo.';
          // this.loading.set(false);
          this.loadingService.hide();
        }
      });
  }

  private extractErrorMessage(error: unknown): string {
    if (error instanceof Error) {
      return error.message;
    }

    if (typeof error === 'string') {
      return error;
    }

    if (
      typeof error === 'object' &&
      error !== null &&
      'message' in error &&
      typeof (error as { message?: unknown }).message === 'string'
    ) {
      return (error as { message: string }).message;
    }

    return 'Error inesperado';
  }

  transformData(data: ObtenerEquipoResponse): DbStore {
    return  {
      tipoPV: data.tipoPV,
      fingerWeb: data.fingerWeb,
      impresoraAlmacen: data.impresoraAlmacen,
      impresoraTienda: data.impresoraTienda,
      impresoraZebra: data.impresoraZebra,
      nev: data.nev,
      paisOriginal: data.paisOriginal,
      puntoVentaOriginal: data.pvOriginal.puntoVenta,
      registro: new Date().toString(),
      cambiarPV: Boolean(data.cambiarPV),
      key: 'store-id',
      sesionMultiple: Boolean(data.sesionMultiple),
      nuevaPantalla: Boolean(data.nev),
      pais: data.paisOriginal,
      descripcionPais: data.paisOriginal,
      esSociedad: false,
      paisActivo: false,
      activo: data.pvOriginal.activo,
      descripcionPuntoVenta: data.pvOriginal.descripcion,
      descripcionPuntoOriginal: data.pvOriginal.descripcion,
      puntoVenta: data.pvOriginal.puntoVenta,
      value: this.deviceId,
      pvDefault: true,
      razonSocial: data.pvOriginal.razonSocial.SRazonSocial,
      imagenFondo: data.pvOriginal.razonSocial.abreviatura
    }
  }

  logout() {
    this.user = this.session.rawBackend;
    if(this.user()){
      this.auth.logout().subscribe({
        next: () => {
          this.router.navigateByUrl('/login', { replaceUrl: true });
          this.loadingService.hide();
        },
        error: err => console.error('Error en logout', err)
      });
    } else {
      this.loading.set(false);
      this.loadingService.hide();
    }

  }

  revisaStore(): boolean {
    return this.store!.puntoVenta !== this.store!.puntoVentaOriginal;
  }

  abrirConfiguracion() {
    this.ref = this.dialogService.open(ConfiguracionTemporalModal, {
      header: 'Configuración',
      width: '600px',
      modal: true,
      closable: true,
      dismissableMask: true
    });

    this.ref?.onClose.subscribe(async (data) => {
      window.location.reload();
    });
  }

  navegarRegistro(){
    this.router.navigateByUrl('/AdminRegistro', { replaceUrl: true });
  }

  idleOK() {
    this.showidleModal = false;
    localStorage.removeItem('idle');
  }

  private registrarEquipoSilencioso(): Promise<boolean> {
    return new Promise(resolve => {
      let data: RegistrarEquipoInterface;

      try {
        data = this.fillDataRegistroRapido();
      } catch {
        this.errorMessage = 'Selecciona una Sociedad';
        resolve(false);
        return;
      }

      this.registroEquipo.registrarEquipo(data).subscribe({
        next: async response => {
          if (response.exception) {
            this.errorMessage =
              this.extractErrorMessage(response.exception);

            resolve(false);
            return;
          }

          const guardado = await this.obtenerYGuardarEquipo();
          resolve(guardado);
        },
        error: error => {
          console.error(
            'Error en registro silencioso',
            error
          );

          this.errorMessage =
            'Las credenciales son correctas, pero no fue posible registrar el equipo.';

          resolve(false);
        }
      });
    });
  }

  fillDataRegistroRapido(): RegistrarEquipoInterface {
    const corporativo = this.corporativoSeleccionado();

    if (!corporativo) {
      throw new Error('No se ha seleccionado una sociedad');
    }
    const { email } = this.form.value;
    return {
      pais: corporativo.pais,

      payload: {
        impresoraTienda: '',
        tipoVenta: corporativo.tipoPuntoVenta,
        impresoraAlmacen: '',
        sesionMultiple: 0,
        impresoraZebra: '',
        cambiarPV: 1,

        pvOriginal: corporativo.puntoVenta,
        nev: 1,
        fingerWeb: this.deviceId,
        paisOriginal: corporativo.pais,
        impresionWEBTienda: 0,
        impresionWEBZebra: 0,
        default: 1,
        listaRegistroSesionPuntoVenta: [
          {
            id: {
              pais: corporativo.pais
            },
            puntoVenta: corporativo.puntoVenta,
            default: 1,
            tipoPuntoVenta: corporativo.tipoPuntoVenta
          }
        ]
      },

      puntoVenta: corporativo.puntoVenta,

      usuario: email ? String(email) : 'UBATCH'
    };
  }

  private obtenerYGuardarEquipo(): Promise<boolean> {
    return new Promise(resolve => {
      const request: ObtenerEquipoRequest = {
        payload: {
          fingerWeb: this.deviceId
        }
      };

      this.registroEquipo.obtenerEquipo(request).subscribe({
        next: async response => {
          if (!response.payload) {
            this.errorMessage =
              'No fue posible obtener la configuración del equipo';

            resolve(false);
            return;
          }

          const dataStore =
            this.transformData(response.payload);

          await this.storeDb.saveStore(dataStore);

          this.store =
            await this.storeDbService.getConfig();

          this.equipoRegistrado.set(true);

          resolve(true);
        },
        error: error => {
          console.error(
            'Error consultando equipo registrado',
            error
          );

          this.errorMessage =
            'El equipo se registró, pero no fue posible obtener su configuración.';

          resolve(false);
        }
      });
    });
  }
}
